// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const masterDocumentService = {};

masterDocumentService.getMasterDocumentList = function () {
  return lossClient({
    url: "/reference/productDocument",
    method: "get",
  });
};

export default masterDocumentService;
